import { Box } from '@mui/material';

import { normalizeSx } from '@/shared/lib/normalizeSx';

import type { Sx } from '@/shared/types/uiTypes';

type TagProps = {
  label?: string;
  variant?: 'default' | 'large';
  sx?: Sx;
};

const variantSx: Record<'default' | 'large', Sx> = {
  default: {},
  large: { height: 20, px: '6px', fontSize: 10, fontWeight: 600 }
};

const labelSx: Sx = {
  display: 'block',
  lineHeight: 1,
  position: 'relative'
};

export const Tag = ({ label = 'beta', variant = 'default', sx }: TagProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: label === 'beta' ? 'gx.actionBarButtonTile' : 'gx.highlight',
          fontSize: '8px',
          textTransform: 'uppercase',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          lineHeight: 1,
          px: '4px',
          minWidth: '36px',
          letterSpacing: 0,
          height: '12px'
        },
        ...normalizeSx(variantSx[variant]),
        ...normalizeSx(sx)
      ]}
    >
      <Box
        component='span'
        sx={labelSx}
      >
        {label}
      </Box>
    </Box>
  );
};
